<script>
export default {
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
    dealNameInputPlaceholder: {
      type: String,
      default: 'Nome do negócio',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      dealName: '',
      pipeCode: '',
      currentStage: '',
    };
  },
  mounted() {
    this.dealName = this.modelValue[0]?.deal_name;
    this.pipeCode = this.modelValue[0]?.pipe_code;
    this.currentStage = this.modelValue[0]?.current_stage;
    this.updateValue();
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', {
        deal_name: this.dealName,
        pipe_code: this.pipeCode,
        current_stage: this.currentStage,
      });
    },
  },
};
</script>

<template>
  <div>
    <div class="[&>input]:mb-0 [&>input]:mt-1">
      <input
        v-model="dealName"
        type="text"
        :placeholder="dealNameInputPlaceholder"
        @input="updateValue"
      />
      <input
        v-model="pipeCode"
        type="text"
        placeholder="ID do funil"
        @input="updateValue"
      />
      <input
        v-model="currentStage"
        type="text"
        placeholder="ID da etapa"
        @input="updateValue"
      />
    </div>
  </div>
</template>
